import { render, staticRenderFns } from "./DetailPool.vue?vue&type=template&id=2da58e90&scoped=true&"
import script from "./DetailPool.vue?vue&type=script&lang=js&"
export * from "./DetailPool.vue?vue&type=script&lang=js&"
import style0 from "./DetailPool.vue?vue&type=style&index=0&id=2da58e90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da58e90",
  null
  
)

export default component.exports